import { render, staticRenderFns } from "./UsersAnalysis.vue?vue&type=template&id=9b15d7bc"
import script from "./UsersAnalysis.vue?vue&type=script&lang=js"
export * from "./UsersAnalysis.vue?vue&type=script&lang=js"
import style0 from "./UsersAnalysis.vue?vue&type=style&index=0&id=9b15d7bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports